import {
    EstadosArticulo,
    Exact,
    InputMaybe,
    PageOptionsArgs,
    Scalars,
    TipoArticulo,
    TipoOrdenamiento,
} from "src/gql/schema"
import { FilterSortState } from "../interfaces/filterSortState"
import { TODOS_CATEGORIA_FILTER } from "../hooks/useGetRecetasProcesos"

export type GetRecetasProps = | Exact<{
    filter_tipo_articulo: Array<TipoArticulo> | TipoArticulo
    pagination_options: PageOptionsArgs
    filterEstadoArticulo?: InputMaybe<EstadosArticulo>
    categoria_articulo_ids?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>
    hotel_id: Scalars["ID"]["input"]
    nombreArticuloFilterOrder?: InputMaybe<TipoOrdenamiento>
}>
| undefined

export const getRecetasProcesosQueryFilters = ({
    page,
    categoria_tipoSelected,
    categorias_tipo,
    filterSortState,
    hotel_id,
}: {
    page: number
    categoria_tipoSelected: {
        name: string | TipoArticulo.Proceso
        id: string
    }
    categorias_tipo: {
        name: string | TipoArticulo.Proceso
        id: string
    }[]
    filterSortState?: FilterSortState
    hotel_id: string
}): GetRecetasProps => {
    const categoriasAlimentosBebidas = categorias_tipo
        .filter(c => c.name === "Alimentos" || c.name === "Bebidas")
        .map(c => c.id)

    // 🔹 nombre orden
    const nombreArticuloFilterOrder =
        filterSortState?.nameSort?.sort
            ? filterSortState.nameSort.sort === "down"
                ? TipoOrdenamiento.Asc
                : TipoOrdenamiento.Desc
            : undefined

    // 🔹 estado
    const filterEstadoArticulo = filterSortState?.estatusFilters ?? undefined

    // 🔹 tipo artículo
    let filter_tipo_articulo: TipoArticulo[] = [TipoArticulo.Proceso, TipoArticulo.Receta]

    if (filterSortState?.tipoFilters?.length) {
        filter_tipo_articulo = filterSortState.tipoFilters.map(
            t => t.filter as TipoArticulo
        )
    } else if (
        categoria_tipoSelected.name === "Alimentos" ||
        categoria_tipoSelected.name === "Bebidas"
    ) {
        filter_tipo_articulo = [TipoArticulo.Receta]
    } else if (categoria_tipoSelected.name === TipoArticulo.Proceso) {
        filter_tipo_articulo = [TipoArticulo.Proceso]
    }

    let categoria_articulo_ids: string[] | null | undefined = undefined

    if (categoria_tipoSelected.name === TODOS_CATEGORIA_FILTER.label) {
        categoria_articulo_ids = filterSortState?.categoriaFilters?.length
            ? filterSortState.categoriaFilters.map(f => f.filter)
            : categoriasAlimentosBebidas
    } else if (
        categoria_tipoSelected.name === "Alimentos" ||
        categoria_tipoSelected.name === "Bebidas"
    ) {
        categoria_articulo_ids = [categoria_tipoSelected.id]
    } else if (categoria_tipoSelected.name === TipoArticulo.Proceso) {
        categoria_articulo_ids = null
    }

    return {
        hotel_id,
        pagination_options: {
            page,
            take: 12,
        },
        filter_tipo_articulo,
        filterEstadoArticulo,
        categoria_articulo_ids,
        nombreArticuloFilterOrder,
    }
}
